/**
 * Two-tier wordlist data — same shape as lessons.ts. Index ships with the
 * home page; full bundle is lazy-loaded via dynamic import.
 */

import indexJson from './wordlists-index.json';
import type { Lesson, LessonsBundle } from './types';
import type { FlatVocab, LessonMeta } from './lessons';

const index = indexJson as { lessons: LessonMeta[] };
export const wordlistsIndex: LessonMeta[] = index.lessons;
export const totalWordlistVocabCount: number = wordlistsIndex.reduce(
  (s, l) => s + l.vocabCount,
  0,
);

export function wordlistMetaByNumber(n: number): LessonMeta | undefined {
  return wordlistsIndex.find((l) => l.number === n);
}

let _bundlePromise: Promise<LessonsBundle> | null = null;

export function loadWordlists(): Promise<LessonsBundle> {
  if (!_bundlePromise) {
    _bundlePromise = import('./wordlists.json').then(
      (m) => (m as unknown as { default: LessonsBundle }).default,
    );
  }
  return _bundlePromise;
}

export async function wordlistByNumber(n: number): Promise<Lesson | undefined> {
  const bundle = await loadWordlists();
  return bundle.lessons.find((l) => l.number === n);
}

export async function wordlistByIdParam(idParam: string): Promise<Lesson | undefined> {
  const bundle = await loadWordlists();
  const n = Number.parseInt(idParam, 10);
  if (!Number.isNaN(n)) return bundle.lessons.find((l) => l.number === n);
  return bundle.lessons.find((l) => l.id === idParam);
}

export async function nextWordlist(n: number): Promise<Lesson | undefined> {
  return wordlistByNumber(n + 1);
}
export async function previousWordlist(n: number): Promise<Lesson | undefined> {
  return wordlistByNumber(n - 1);
}

export async function allWordlistVocabFlat(): Promise<FlatVocab[]> {
  const bundle = await loadWordlists();
  const out: FlatVocab[] = [];
  for (const l of bundle.lessons) {
    for (const section of l.sections) {
      if (section.type !== 'vocab') continue;
      for (const item of section.items) {
        out.push({
          ...item,
          kind: 'wordlist',
          lessonNumber: l.number,
          lessonTitle: l.title,
        });
      }
    }
  }
  return out;
}
